import  {apis,request,methods} from "../request";

 export const httpProductDetails = (category_slug,product_slug) => {
    // console.log('cate'.category_slug)
    //  console.log('product'.product_slug)
    return request(methods.get, `${apis.productDetails}${category_slug}/${product_slug}`);
}
